import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=4924a742&"
import script from "./confirm-dialog.vue?vue&type=script&lang=js&"
export * from "./confirm-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports